<rappider-form-with-guidance *ngIf="isAmazonS3FormVisible"
                             [editFormConfig]="editFormConfig"
                             [content]="content"
                             [errorAlertConfig]="errorAlertConfig"
                             [submitButtonLoading]="submitButtonLoading"
                             (formSubmit)="onFormSubmit($event)"></rappider-form-with-guidance>
<section class="section-wrapper">
  <rappider-spin [spinning]="loading"
                [size]="'default'">
    <div *ngIf="!isAmazonS3FormVisible"
              class="connect-wrapper">
      <rappider-icon [name]="(!connectedAccount?.id || !alertVisible || !(connectedAccount?.drivePermissionGranted !== false)) ? 'fa-solid fa-lock-keyhole' : 'fa-solid fa-unlock-keyhole'"
                    [type]="connectIcon.type"
                    [size]="connectIcon.size"></rappider-icon>
      <rappider-alert *ngIf="alertVisible && connectedAccount?.drivePermissionGranted === false"
                      [type]="'warning'"
                      [title]="{content:'You have successfully connected your Google account',type:'h4'}"
                      [description]="'However, you did not grant access to your Google Drive files. To allow us to access your files, please reconnect and grant the required permission'"
                      [showIcon]="connectAlertConfig.showIcon"
                      [closeable]="connectAlertConfig.closeable"></rappider-alert>
      <rappider-alert *ngIf="alertVisible && connectedAccount?.drivePermissionGranted !== false"
                      [type]="(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false) ? 'success' : connectAlertConfig.type"
                      [title]="(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false) ? {content:successfullyConnectText,type:'h4'} : {content:failedConnectText,type:'h4'}"
                      [description]="(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false) ? {text:successfullyInformationText} : {text:failedInformationText}"
                      [showIcon]="connectAlertConfig.showIcon"
                      [closeable]="connectAlertConfig.closeable"></rappider-alert>
      <div class="descriptions-button-group-wrapper">
        <div *ngIf="connectedAccount?.id" class="connect-descriptions-status-wrapper">
          <nz-descriptions [nzColumn]="1" nzBordered *ngFor="let description of descriptions | keyvalue">
          <nz-descriptions-item [nzTitle]="description.key">{{alertVisible ? description?.value : ''}}</nz-descriptions-item>
        </nz-descriptions>
        <nz-descriptions [nzColumn]="1" nzBordered>
          <nz-descriptions-item nzTitle="Verified" [nzSpan]="3"><nz-badge [nzStatus]="(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false) ? 'success' : (connectedAccount?.id && connectedAccount?.drivePermissionGranted === false) ? 'warning' : 'error'" [nzText]="(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false) ? 'connected' : 'failed'"></nz-badge></nz-descriptions-item>
        </nz-descriptions>
        </div>
        <rappider-checkbox *ngIf="activePersonId === connectedAccount?.personId && connectedAccount?.id"
                           [(ngModel)]="connectedAccount.isFileAccessShared"
                           [text]="{ text: 'I give permission for other project members to access my files.' }"
                           (valueChange)="onIsFileAccessSharedChange($event)"></rappider-checkbox>
        <div class="button-group">
          <a *ngIf="activeProvider !== ProvidersType.AmazonS3 && (!connectedAccount?.id || connectedAccount?.drivePermissionGranted === false)"
              class="refresh-connect-button"
              [href]="connectUrl"><span
              class="refresh-connect-button-content">Connect</span></a>
          <rappider-button *ngIf="connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false"
                           [text]="'Disconnect'"
                           popconfirmTitle="Are you sure you want to disconnect your account?"
                           [emitWithoutPopconfirm]="false"
                           popconfirmCancelText="Cancel"
                           popconfirmOkText="Disconnect"
                           [popconfirmOkDanger]= "true"
                           [type]="'default'"
                           (confirm)="disconnect()"></rappider-button>
          <rappider-button *ngIf="activeProvider === ProvidersType.AmazonS3 && (!connectedAccount?.id || connectedAccount?.drivePermissionGranted === false)"
                          [text]="'Connect'"
                          [type]="'default'"
                          (click)="refreshConnectButtonClick()"></rappider-button>
          <rappider-button class="go-to-file-list-button"
                          [text]="'Go to File List'"
                          [loading]="submitButtonLoading"
                          type="primary"
                          [disabled]="!(connectedAccount?.id && connectedAccount?.drivePermissionGranted !== false)"
                          (click)="goToFileListButtonClick()"></rappider-button>
        </div>
      </div>
    </div>
  </rappider-spin>
</section>
